/**
 * Full-screen loader shown until the cold-start /auth/refresh resolves.
 * Prevents the welcome screen from flashing briefly before AuthGate
 * reads the resolved auth state.
 */
export function AppLoader({ label }: { label?: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      aria-label={label ?? 'Loading'}
      className="fixed inset-0 z-50 flex flex-col items-center justify-center bg-cream-50 dark:bg-midnight-950"
    >
      <div className="flex flex-col items-center gap-4">
        <div
          className="h-10 w-10 animate-spin rounded-full border-2 border-jade-500 border-t-transparent"
          aria-hidden="true"
        />
        <span className="font-serif text-sm tracking-wide text-ink-600 dark:text-warm-200">
          {label ?? 'Loading…'}
        </span>
      </div>
    </div>
  );
}
